module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr8-de31d851c7b3dcdd672758759d2518a1.jpg";